module.exports = __webpack_public_path__ + "img/AL271-1-EN.d4f1a67b.jpg";